import { Card, CardHeader, CardContent, Stack, TextField, CardActions, Typography, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createBranch } from '../store/branchActions';

const branchSchema = yup.object({
  name: yup.string().required('Branch name is required'),
  location_code: yup.string().required('Location code is required'),
});

BranchForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function BranchForm({ open, onClose }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.branchReducer);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const onSubmit = (values, { resetForm }) => {
    dispatch(createBranch(values));
    resetForm();
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: {
      name: '',
      location_code: '',
    },
    validationSchema: branchSchema,
    onSubmit,
  });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="branch-form-title">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '500px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardHeader id="branch-form-title" title="New Branch" />
          <CardContent>
            <Stack spacing={2}>
              <TextField
                name="name"
                type="text"
                label="Branch Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
              />
              {touched.name && Boolean(errors.name) && (
                <Typography color="error" variant="body2">
                  {errors.name}
                </Typography>
              )}
              <TextField
                name="location_code"
                type="text"
                label="Location Code"
                value={values.location_code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.location_code && Boolean(errors.location_code)}
              />
              {touched.location_code && Boolean(errors.location_code) && (
                <Typography color="error" variant="body2">
                  {errors.location_code}
                </Typography>
              )}
            </Stack>
          </CardContent>
          <CardActions>
            <LoadingButton color="error" variant="contained" onClick={onClose}>
              Cancel
            </LoadingButton>
            <LoadingButton loading={isLoading} type="submit" variant="contained">
              Submit
            </LoadingButton>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
